module.exports = __webpack_public_path__ + "static/green_dragon-7025c626ddcf67de9036966a8a895db7.png";